import { Input } from "./../../PaymentsOptionsContainer/styles";
import styled from "styled-components";

export const InputRadioContainerStyle = styled.label`
  display: flex;
  gap: 0 8px;
  align-items: center;
  position: relative;
  cursor: pointer;

  span {
    color: #111;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }

  input {
    opacity: 0;
    position: absolute;
  }

  &::before {
    content: "";
    display: block;
    background-image: url("/assets/imgs/square-outlined.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 18px;
    height: 18px;
  }

  &:has(input:checked)::after {
    content: "";
    position: absolute;
    display: block;
    width: 18px;
    height: 18px;
    background-image: url("/assets/imgs/square-filled.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
`;
